export default __webpack_public_path__ + "static/media/edge-logo.c8df86ba.png";